// Testi hardcoded della promo-card (specchio di promo_card_texts() in promozioni.php)
function promoCardTexts(name) {
    const u = (name || '').trim().toUpperCase();
    if (u.includes('MENO CARO')) {
        return { ribbon: '1 Free', value: 'Meno caro Gratis', title: 'Acquistando 3 corsi' };
    }
    if (u.includes('GLOBAL CARD')) {
        return { ribbon: '2026', value: 'Global Card', title: 'Accesso a tutti i corsi ECM FAD' };
    }
    const m = u.match(/SCONTO\s+(\d+)/);
    if (m) {
        const n = parseInt(m[1], 10);
        const courses = n >= 40 ? 4 : (n >= 20 ? 3 : 2);
        return { ribbon: 'Sconto', value: '-' + n + '%', title: 'Acquistando ' + courses + ' corsi' };
    }
    return { ribbon: '', value: name || '', title: '' };
}

export function registerPromoSlider(Alpine) {
    Alpine.data('promoSlider', () => ({
        current: 0,
        timer: null,
        slides: [],
        wrapHeight: 'auto',

        init() {
            const items = window.IKOS?.promotions || [];
            this.slides = items.map(item => {
                const imageTitle = item.image_title || '';
                const useCard = imageTitle.includes('ik-promo-card');
                const card = useCard ? promoCardTexts(item.name) : null;
                const isGlobal = useCard && imageTitle.includes('--global');
                return {
                    eyebrow: item.slogan || 'Promozione',
                    title: item.name || '',
                    desc: item.short_description || item.description || '',
                    cta: 'Scopri di più',
                    url: '/promozioni',
                    image: item.image || null,
                    useCard,
                    cardClass: imageTitle,
                    cardRibbon: card ? card.ribbon : '',
                    cardValue: card ? card.value : '',
                    cardTitle: card ? card.title : '',
                    cardLogo: isGlobal ? '/assets/ds/img/logo-white.png' : '/assets/ds/img/logo.png',
                };
            });
            if (this.slides.length) {
                this.startAutoplay();
            }
        },

        updateHeight() {
            const wrap = this.$refs.slides;
            if (!wrap) return;
            const visible = wrap.querySelector('.ik-mega-menu__promo-slide:not([style*="display: none"])');
            if (!visible || visible.scrollHeight === 0) {
                this.wrapHeight = 'auto';
                return;
            }
            // Prima transizione: fissa l'altezza corrente in px (no animazione da auto)
            if (this.wrapHeight === 'auto') {
                wrap.style.transition = 'none';
                this.wrapHeight = wrap.scrollHeight + 'px';
                wrap.offsetHeight; // force reflow
                wrap.style.transition = '';
            }
            this.wrapHeight = visible.scrollHeight + 'px';
        },

        startAutoplay() {
            this.timer = setInterval(() => this.next(), 4000);
        },

        stopAutoplay() {
            clearInterval(this.timer);
        },

        prev() {
            this.stopAutoplay();
            this.current = (this.current - 1 + this.slides.length) % this.slides.length;
            this.$nextTick(() => this.updateHeight());
            this.startAutoplay();
        },

        next() {
            this.current = (this.current + 1) % this.slides.length;
            this.$nextTick(() => this.updateHeight());
        },

        goTo(index) {
            this.stopAutoplay();
            this.current = index;
            this.$nextTick(() => this.updateHeight());
            this.startAutoplay();
        },

        destroy() {
            this.stopAutoplay();
        },
    }));
}
